import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRGlassProductCostBody,
  CRGlassProductCostBodyAPI,
  CRGlassProductCostKey,
  CRGlassProductCostSummary,
  CRGlassProductCostSummaryAPI,
  GlassProductCostsActions,
  GlassProductCostsState,
} from './types';

type AnyGlassProductCost =
  | CRGlassProductCostKey
  | CRGlassProductCostSummary
  | CRGlassProductCostBody
  | undefined;

function sameKeyGlassProductCost(
  a: AnyGlassProductCost,
  b: AnyGlassProductCost,
): boolean {
  return (
    a?.supplierId === b?.supplierId &&
    a?.priceBracketId === b?.priceBracketId &&
    a?.priceBookId === b?.priceBookId &&
    a?.glassProductId === b?.glassProductId &&
    a?.glassPricingMethod === b?.glassPricingMethod
  );
}

function getEndpointGlassProductCost(key: AnyGlassProductCost): string {
  return key
    ? `/glass-product-costs/${key.supplierId ?? 0}/${key.priceBracketId ?? 0}/${
        key.priceBookId ?? 0
      }/${key.glassProductId}/${key.glassPricingMethod}/`
    : '/glass-product-costs/';
}

function parseGlassProductCostSummary(
  glassProductCostSummary: CRGlassProductCostSummaryAPI,
): CRGlassProductCostSummary {
  return glassProductCostSummary;
}

function parseGlassProductCostBody(
  glassProductCostDetail: CRGlassProductCostBodyAPI,
): CRGlassProductCostBody {
  return glassProductCostDetail;
}

const glassProductCostsStateSelector = (state: any): GlassProductCostsState =>
  state.glassProductCosts;

const glassProductCostsKeySelector = ({
  supplierId,
  priceBracketId,
  priceBookId,
  glassProductId,
  glassPricingMethod,
}:
  | CRGlassProductCostBody
  | CRGlassProductCostSummary): CRGlassProductCostKey => ({
  supplierId,
  priceBracketId,
  priceBookId,
  glassProductId,
  glassPricingMethod,
});

function mergeGlassProductCostBody(
  lastBody: CRGlassProductCostBody,
  currentBody: CRGlassProductCostBody,
) {
  return currentBody;
}

function combineSummaryBodyGlassProductCost(
  summary?: CRGlassProductCostSummary,
  body?: CRGlassProductCostBody,
): CRGlassProductCostSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    ...summary,
    rowKey: summary?.rowKey ?? body?.rowKey ?? '',
    supplierId: merge('supplierId'),
    priceBookId: merge('priceBookId'),
    priceBracketId: merge('priceBracketId'),
    glassProductId: merge('glassProductId'),
    glassPricingMethod: merge('glassPricingMethod'),
    costPerSquareUnit: merge('costPerSquareUnit'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'glassProductCosts',
  getEndpointGlassProductCost,
  glassProductCostsStateSelector,
  sameKeyGlassProductCost,
  parseGlassProductCostBody,
  parseGlassProductCostSummary,
  mergeGlassProductCostBody,
  combineSummaryBodyGlassProductCost,
);

const glassProductCostsActions: GlassProductCostsActions = actions;
export * from './types';
export {
  glassProductCostsActions,
  reducer as glassProductCostsReducer,
  watches as glassProductCostsWatches,
  glassProductCostsStateSelector,
  glassProductCostsKeySelector,
};
